import { useQuery } from "@tanstack/react-query";
import { fetchWarehouseCodePrefix } from "../../../../../../enums/queryFunction/Fetch";
import { WAREHOUSE_CODE_PREFIX } from "../../../../../../enums/QueryKeys";

export function useGetWarehouseCodePrefix(clinicId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [WAREHOUSE_CODE_PREFIX, clinicId],
    queryFn: () => fetchWarehouseCodePrefix(clinicId),
    enabled: Boolean(clinicId),
  });

  return { data, isLoading, error, refetch };
}
